export const capitalizeFirstLetter = (str: string) =>
  str.toLowerCase().charAt(0).toUpperCase() + str.toLowerCase().slice(1);
